import { Input } from '@rabbit/elements/shared-components';
import { AGE_RANGE_OPTIONS } from '@rabbit/olive/utils/consts';
export type ConditionalProfileFieldsProps = {
  showPhone: boolean;
  showAgeRange: boolean;  
  containerClassName?: string;
};

export const ConditionalProfileFields = ({
  showPhone,
  showAgeRange,
  containerClassName,
}: ConditionalProfileFieldsProps) => {
  return (
    <div
      className={
        containerClassName ??
        'flex w-full max-w-[360px] flex-col gap-4 mx-auto'
      }
    >
      {showPhone && (
        <div className="space-y-1 font-nunito">
          <Input
            type="phone"
            name="phone"
            label="Phone number"
            settings={{
              id: 'phone',
              placeholder: 'Enter your phone number',
            }}
          />
        </div>
      )}

      {showAgeRange && (
        <div className="space-y-1 font-nunito">
          <Input
            type="select"
            name="age_bracket"
            label="Age range"
            settings={{
              id: 'age_bracket',
              placeholder: 'Select your age range',
              options: AGE_RANGE_OPTIONS,
            }}
          />
        </div>
      )}
    </div>
  );
};
